import React, { useMemo } from 'react'

import { Pill } from '@components/pill/pill.component'
import { Icon } from '@components/icon.component'
import { Select } from '@components/mantine/select.component'

type PillSelectItem = {
  id: string
  name: string
}

type PillSelectProps = {
  data: PillSelectItem[]
  value: PillSelectItem | null
  onChange: (item: PillSelectItem) => void
  className?: string
  [key: string]: any
}

export function PillSelect({ data, value, onChange, className, ...rest }: PillSelectProps) {
  const selectData = useMemo(
    () => data.map(item => ({ value: item.id, label: item.name })),
    [data],
  )

  return (
    <div
      className={className}
    >
      <Select
        {...rest}
        data={selectData}
        value={value?.id}
        onChange={(val: string | null) => {
          const selected = data.find(item => item.id === val)
          if (selected) onChange(selected)
        }}
        renderTrigger={({ selectedLabel, toggle }: { selectedLabel: string; toggle: () => void }) => (
          <button
            className="flex cursor-pointer items-center border-0 bg-transparent p-0 focus:outline-none"
            onClick={toggle}
          >
            <Pill>
              {selectedLabel}
              <Icon
                className="ml-1"
                name="caret-down"
                size={14}
              />
            </Pill>
          </button>
        )}
      />
    </div>
  )
}
